import { render, staticRenderFns } from "./DialogMessage.vue?vue&type=template&id=2e09fd34"
import script from "./DialogMessage.vue?vue&type=script&lang=js"
export * from "./DialogMessage.vue?vue&type=script&lang=js"
import style0 from "./DialogMessage.vue?vue&type=style&index=0&id=2e09fd34&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports